import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DownloadFile } from 'src/app/model/asd/asd-properties/asd-downloadFile';
import { InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { BreadCrumbItem } from 'src/app/model/breadCrumb/breadCrumbItem';
import { FormBase } from 'src/app/model/form/form';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { CosyCommunicationControllerService } from 'src/app/service/controller/cosy-communication-controller.service';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';

@Component({
  selector: 'app-cosy-ribbon',
  templateUrl: './cosy-ribbon.component.html',
  styleUrls: ['./cosy-ribbon.component.css']
})
export class CosyRibbonComponent implements OnInit {
  @Input() ie: InterfaceElement;
  @Input() cosyFormInit : FormBase;
  @Input() downloadFile: DownloadFile;
  @Input() ieCompleteList: InterfaceElement[] = [];
  @Input() breadCrumb: BreadCrumbItem[] = [];
  @Output() loadHistory: EventEmitter<any> = new EventEmitter<any>();

  public IE_TYPES = InterfaceElementTypes;
  public isFromRibbon: boolean = true;
  sessionID: any;
  constructor(private cosyCommunicationControllerService: CosyCommunicationControllerService,
              private ux:UXControllerService ) { }

  ngOnInit(): void {
    this.sessionID = this.cosyCommunicationControllerService.localSessionID;
    for(let iee of this.ie.InterfaceElements){
      let assignedCSS : string = iee.Attributes.AssignedColumnWidth;
      if(assignedCSS!= null){
        let colIndex : number = assignedCSS.indexOf('col-');
        if(colIndex>-1){
          iee.Attributes.AssignedColumnWidth = assignedCSS.substring(colIndex, colIndex+9);
        }
      }
    }
   
  }
  loadHistorytoBreadCrumb(sessionID: any){
    this.loadHistory.emit(sessionID);
  }
}
